import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {map, take, catchError, of, Observable, timeout} from 'rxjs';
import {UserService} from '@core/user/user.service';
import {User} from '@models/user.interface';
import {GuardResultType} from '@models/guard-result.type';
import {AccountRole} from '@enums/AccountRole';

@Injectable({
    providedIn: 'root'
})
export class SemiMasterAllowedHotelsGuard  {

    constructor(private readonly _userService: UserService, private readonly _router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResultType {
        const hotelId = route.params.hotelId;

        return this._userService.user$.pipe(
            take(1),
            map((user: User): boolean => {
                if (!user) {
                    console.warn('No user authenticated, redirecting to sign-in');
                    void this._router.navigate(['/sign-in']);
                    return false;
                }

                if (user.rol === AccountRole.master) return true; // ? Master accounts are always allowed

                if (user.rol === AccountRole.semiMaster) {
                    const allowedHotels: number[] = user?.boundedHotels ?? [];
                    const isHotelAllowed: boolean = allowedHotels.includes(Number(hotelId));
                    if (!isHotelAllowed) {
                        console.warn('Access denied: Hotel not allowed for this user');
                        void this._router.navigate(['/404-not-found']);
                        return false;
                    }
                }

                /*
                 ?For other roles, we assume access is allowed or
                 ?if the user is a semi-master and the hotelId is allowed
                 */
                return true;
            }),
            timeout(5000),
            catchError((e): Observable<boolean> => {
                if (e.name === 'TimeoutError')
                    console.error('Request timed out for user in SemiMasterAllowedHotelsGuard');

                void this._router.navigate(['/404-not-found']);
                return of(false);
            })
        );
    }
}
